module.exports = __webpack_public_path__ + "img/24.7350e71f.svg";